import { photoUrl } from "../lib/api";

// Round category photo with an admin-chosen focus point (pos "x% y%") and zoom (100–300).
export function CategoryPhoto({ src, pos, zoom, className = "", ...rest }) {
  const p = pos || "50% 50%";
  return (
    <span className={`block rounded-full overflow-hidden shrink-0 ${className}`} {...rest}>
      <img src={photoUrl(src)} alt="" loading="lazy" draggable={false}
        className="h-full w-full object-cover pointer-events-none select-none"
        style={{ objectPosition: p, transform: `scale(${(zoom || 100) / 100})`, transformOrigin: p }} />
    </span>
  );
}
